export interface Helpline {
  name: string;
  region: string;
  url: string;
  phone?: string;
}

export const HELPLINES: Helpline[] = [
  {
    name: "GamCare",
    region: "United Kingdom",
    url: "https://www.gamcare.org.uk/",
    phone: "0808 8020 133",
  },
  {
    name: "BeGambleAware",
    region: "United Kingdom",
    url: "https://www.begambleaware.org/",
  },
  {
    name: "Gambling Therapy",
    region: "International",
    url: "https://www.gamblingtherapy.org/",
  },
  {
    name: "Gamblers Anonymous",
    region: "United States",
    url: "https://www.gamblersanonymous.org/",
  },
  {
    name: "National Council on Problem Gambling",
    region: "United States",
    url: "https://www.ncpgambling.org/",
    phone: "1-800-GAMBLER",
  },
  {
    name: "Spelpaus",
    region: "Sweden",
    url: "https://www.spelpaus.se/",
  },
  {
    name: "Gambling Help Online",
    region: "Australia",
    url: "https://www.gamblinghelponline.org.au/",
  },
  {
    name: "Responsible Gambling Council",
    region: "Canada",
    url: "https://www.responsiblegambling.org/",
  },
  {
    name: "Jogadores Anônimos",
    region: "Brazil",
    url: "https://jogadoresanonimos.com.br/",
  },
];
